/**
 * Bill entity type DTO enum - matches backend API contract
 * Represents the type of entity associated with a bill line item
 */
export enum BillEntityTypeDTO {
  PROJECT = 'PROJECT',
  CLIENT = 'CLIENT',
  NONE = 'NONE',
  TIME_OFF_TYPE = 'TIME_OFF_TYPE',
  OVERHEAD = 'OVERHEAD',
  /**
   * A member's fixed monthly salary as the bill's only line (nothing else selected).
   * Booked against the member's department with no project attribution.
   */
  SALARY = 'SALARY',
  /**
   * The monthly-salary reconciliation line, sent when other lines *were* selected. Same wire
   * shape as OVERHEAD (flat amount + description, may be negative) but booked against its own
   * "Adjustment" product/service in QuickBooks rather than "Overhead".
   */
  ADJUSTMENT = 'ADJUSTMENT',
}

/**
 * Type aliases for clear intent in request/response interfaces
 */
export type BillEntityTypeRequest = BillEntityTypeDTO;
export type BillEntityTypeResponse = BillEntityTypeDTO;
